import React, { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within WishlistProvider');
  }
  return context;
};

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem('jrf-wishlist');
    if (saved) {
      setWishlist(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('jrf-wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const addToWishlist = (garment) => {
    setWishlist(prev => {
      if (prev.find(item => item.id === garment.id)) return prev;
      return [...prev, {
        id: garment.id,
        name: garment.name,
        price: garment.price,
        image_url: garment.image_url || (Array.isArray(garment.images) && garment.images[0]) || '',
        colors: garment.colors,
        gender: garment.gender,
        added_at: new Date().toISOString()
      }];
    });
  };

  const removeFromWishlist = (garmentId) => {
    setWishlist(prev => prev.filter(item => item.id !== garmentId));
  };

  const isInWishlist = (garmentId) => {
    return wishlist.some(item => item.id === garmentId);
  };

  const toggleWishlist = (garment) => {
    if (isInWishlist(garment.id)) {
      removeFromWishlist(garment.id);
    } else {
      addToWishlist(garment);
    }
  };

  const getWishlistCount = () => wishlist.length;

  const value = {
    wishlist,
    addToWishlist,
    removeFromWishlist,
    isInWishlist,
    toggleWishlist,
    getWishlistCount
  };

  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
};
